export const DBNAGENT_SUBSCRIPTIONS_RESET_STATE = 'DBNAGENT_SUBSCRIPTIONS_RESET_STATE';
export const DBNAGENT_SUBSCRIPTIONS_CURRENT_ITEM = 'DBNAGENT_SUBSCRIPTIONS_CURRENT_ITEM';

export const DBNAGENT_SUBSCRIPTIONS_REQUEST_LOADING = 'DBNAGENT_SUBSCRIPTIONS_REQUEST_LOADING';
export const DBNAGENT_SUBSCRIPTIONS_REQUEST_SUCCESS = 'DBNAGENT_SUBSCRIPTIONS_REQUEST_SUCCESS';
export const DBNAGENT_SUBSCRIPTIONS_REQUEST_FAILED = 'DBNAGENT_SUBSCRIPTIONS_REQUEST_FAILED';

export const DBNAGENT_SUBSCRIPTIONS_CURRENT_ACTION = 'DBNAGENT_SUBSCRIPTIONS_CURRENT_ACTION';
export const DBNAGENT_SUBSCRIPTIONS_RESET_ACTION = 'DBNAGENT_SUBSCRIPTIONS_RESET_ACTION';
